import React from 'react'
import styles from './Scaffold.module.css'
import PropTypes from "prop-types"


/**
 *  Scaffold
 *
 *  @param {JSX.Element|string} header
 *  @param {JSX.Element|string} children
 *  @param {JSX.Element|string} footer
 *  @returns {JSX.Element}
 *  @constructor
 */
export default function Scaffold({ header='', children='', footer='' }){
    return (
        <div className={styles.container}>
            <header>{header}</header>
            <main>{children}</main>
            <footer>{footer}</footer>
        </div>
    );
}

Scaffold.propType = {
    header:   PropTypes.oneOfType([ PropTypes.string, PropTypes.element ]),
    footer:   PropTypes.oneOfType([ PropTypes.string, PropTypes.element ]),
    children: PropTypes.oneOfType([ PropTypes.string, PropTypes.element ]),
}